import { z } from 'zod';

import { BasePType } from './base';
import { EmailOptIn } from './email-opt-in';
import { InlineImage } from './inline-image';
import { PrimaryFooterColumn } from './primary-footer-column';
import { RichText } from './rich-text';
import { SocialMediaIcons } from './social-media-icons';

export const NestedSecondColumn = z.array(
  z.union([RichText, EmailOptIn, InlineImage, SocialMediaIcons])
);

export type NestedSecondColumn = z.infer<typeof NestedSecondColumn>;

export const PrimaryFooter = BasePType.extend({
  type: z.enum(['primaryFooter']),
  nestedFirstColumn: z.array(PrimaryFooterColumn),
  nestedSecondColumn: NestedSecondColumn,
});

export type PrimaryFooter = z.infer<typeof PrimaryFooter>;
